import { Flex } from "@chakra-ui/layout";
import React, { useState } from "react";
import colors from "core/resources/theme/colors";
import OutlineButton from "ui/components/Button/OutlineButton";
import { Popover } from "antd";
import { RiBarcodeLine, RiPencilFill, RiCheckLine } from "react-icons/ri";
import { MdDelete, MdKeyboardArrowDown, MdCheck } from "react-icons/md";
import { Box, Text } from "@chakra-ui/react";
import { PermissaoEnum } from "core/resources/enums/permissao";
import { OperacaoEnum } from "core/resources/enums/conta";

function MaisOpcoesConta({
  onEdit,
  onLiquidar,
  onEstornar,
  onDelete,
  onVisualizar,
  showVisualizar = false,
  operacao,
}: {
  onEdit: () => any;
  onDelete: () => any;
  onVisualizar: () => any;
  showVisualizar?: boolean;
  onLiquidar?: () => any;
  onEstornar?: () => any;
  operacao: OperacaoEnum;
}) {
  const [popoverVisible, setPopoverVisible] = useState(false);

  const onClose = () => setPopoverVisible(false);

  return (
    <Flex>
      <Popover
        placement="bottomRight"
        arrowContent={<></>}
        arrowPointAtCenter={false}
        overlayClassName="antd-popover-hide-arrow"
        trigger="click"
        visible={popoverVisible}
        onVisibleChange={setPopoverVisible}
        getPopupContainer={(node: any) => node.parentNode}
        overlayStyle={{
          borderRadius: 12,
          zIndex: 3,
          marginLeft: 10,
          width: onEstornar ? 200 : undefined,
        }}
        overlayInnerStyle={{
          borderRadius: 12,
          boxShadow: "0 0 6px 2px #87878725",
          border: `solid 1px ${colors.blue}`,
          marginTop: -10,
          marginRight: -2,
          padding: 0,
        }}
        content={() => (
          <PopoverContent
            onEdit={onEdit}
            onLiquidar={onLiquidar}
            onEstornar={onEstornar}
            onDelete={onDelete}
            onVisualizar={onVisualizar}
            showVisualizar={showVisualizar}
            onClose={onClose}
            operacao={operacao}
          />
        )}
      >
        <OutlineButton lineColor={colors.blue} p={3}>
          <Text>Mais opções</Text>

          <Box w="20px" ml={-2}>
            <MdKeyboardArrowDown size={25} />
          </Box>
        </OutlineButton>
      </Popover>
    </Flex>
  );
}

const PopoverContent = ({
  operacao,
  onEdit,
  onLiquidar,
  onEstornar,
  onDelete,
  onVisualizar,
  showVisualizar,
  onClose,
}: {
  operacao: OperacaoEnum;
  onEdit: () => any;
  onDelete: () => any;
  onVisualizar: () => any;
  showVisualizar?: boolean;
  onClose: () => any;
  onLiquidar?: () => any;
  onEstornar?: () => any;
}) => (
  <Flex flexDir="column" alignItems="start" w="100px">
    {showVisualizar ? (
      <OutlineButton
        p={0}
        w="100%"
        mb={1}
        border="none"
        onClick={() => {
          onVisualizar();
          onClose();
        }}
      >
        <RiBarcodeLine /> Ver boleto
      </OutlineButton>
    ) : null}
    <OutlineButton
      p={0}
      w="100%"
      justifyContent="start"
      mb={1}
      border="none"
      permissions={
        operacao === OperacaoEnum.Despesa
          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar.Editar
          : PermissaoEnum.Backoffice.Financeiro.ContasReceber.Editar
      }
      onClick={() => {
        onEdit();
        onClose();
      }}
    >
      <RiPencilFill /> Editar
    </OutlineButton>
    {onLiquidar ? (
      <OutlineButton
        p={0}
        w="100%"
        justifyContent="start"
        mb={1}
        border="none"
        permissions={
          operacao === OperacaoEnum.Despesa
            ? PermissaoEnum.Backoffice.Financeiro.ContasPagar.Liquidar
            : PermissaoEnum.Backoffice.Financeiro.ContasReceber.Liquidar
        }
        onClick={() => {
          onLiquidar();
          onClose();
        }}
      >
        <Box w="15px">
          <RiCheckLine size={20} />
        </Box>
        Liquidar
      </OutlineButton>
    ) : null}
    {onEstornar ? (
      <OutlineButton
        p={0}
        w="fit-content"
        justifyContent="start"
        mb={1}
        border="none"
        onClick={() => {
          onEstornar();
          onClose();
        }}
      >
        <Box w="15px">
          <MdCheck size={20} />
        </Box>
        Cancelar liquidação
      </OutlineButton>
    ) : null}
    <OutlineButton
      p={0}
      w="100%"
      justifyContent="start"
      border="none"
      permissions={
        operacao === OperacaoEnum.Despesa
          ? PermissaoEnum.Backoffice.Financeiro.ContasPagar.Excluir
          : PermissaoEnum.Backoffice.Financeiro.ContasReceber.Excluir
      }
      onClick={() => {
        onDelete();
        onClose();
      }}
    >
      <MdDelete /> Excluir
    </OutlineButton>
  </Flex>
);

export default MaisOpcoesConta;
